import styled from 'styled-components';

import colors from '../../../../styles/colors';

const SlotsSection = styled.div`
  flex: 1;
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 300px;
  display: flex;
  flex-direction: column;
`;

const SlotsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid ${colors.shades.gamma3};
`;

const SlotsDate = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  color: ${colors.base.beta};
`;

const SlotsListContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  max-height: 400px;
`;

const SlotItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 8px;
  border-radius: 8px;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  transition: all 0.2s;
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  background: ${({ $selected }) => ($selected ? colors.shades.gamma5 : colors.shades.alpha2)};
  
  &:hover {
    transform: ${({ $disabled }) => ($disabled ? 'none' : 'translateY(-1px)')};
    box-shadow: ${({ $disabled }) => ($disabled ? 'none' : '0 2px 4px rgba(0, 0, 0, 0.1)')};
  }
`;

const SlotTime = styled.div`
  font-size: 1rem;
  font-weight: 500;
  color: ${colors.base.beta};
`;

const SlotSeats = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.9rem;
  color: ${colors.shades.gamma7};
`;

export {
  SlotsSection,
  SlotsHeader,
  SlotsDate,
  SlotsListContainer,
  SlotItem,
  SlotTime,
  SlotSeats,
};
